/**
 * Utils for the MaxEditor component
 */
import { $generateHtmlFromNodes, $generateNodesFromDOM } from '@lexical/html'
import {
  $createParagraphNode,
  $createTextNode,
  $getNodeByKey,
  $getRoot,
  $getSelection,
  $insertNodes,
  LexicalEditor,
} from 'lexical'
import { BeautifulMentionNode } from 'lexical-beautiful-mentions'

/**
 * @param editor
 * @returns string HTML
 */
export function getEditorValueAstHtml(editor: LexicalEditor) {
  return $generateHtmlFromNodes(editor)
}

export function isEditorEmpty(editor: LexicalEditor) {
  // This is considered empty because it only contains a single paragraph with a single line break
  // The mb-3 class is added by the theme config
  return getEditorValueAstHtml(editor) === '<p class="mb-3"><br></p>'
}

/**
 * Updates the editor with the given HTML
 * @param editor
 * @param string html
 */
export function updateEditor(editor: LexicalEditor, html: string) {
  editor.update(() => {
    const parser = new DOMParser()
    const dom = parser.parseFromString(html, 'text/html')
    const nodes = $generateNodesFromDOM(editor, dom)
    $getRoot().clear()
    $insertNodes(nodes)
  })
}

/**
 * Get the users mentioned in the editor via @
 * By traversing the decorators and getting the data of the beautifulMention nodes
 * @param editor
 * @returns
 */
export function getMentions(editor: LexicalEditor) {
  const decorators = editor.getDecorators()
  const mentions = []
  for (const nodeKey in decorators) {
    const node: BeautifulMentionNode = $getNodeByKey(nodeKey)
    if (node?.getType() === 'beautifulMention') {
      mentions.push(node?.getData())
    }
  }
  return mentions
}

/**
 * Appends a text node to the editor
 * @param editor
 */
export function appendTextNode(editor: LexicalEditor, text: string) {
  editor.update(() => {
    const root = $getRoot()
    const selection = $getSelection()
    const paragraphNode = $createParagraphNode()
    const textNode = $createTextNode(text)
    paragraphNode.append(textNode)
    if (selection) {
      selection.insertNodes([paragraphNode])
    } else {
      root.append(paragraphNode)
    }
  })
}
